import React from "react";
import TextField from "@mui/material/TextField";
import {Theme, SimplePaletteColorOptions} from "@mui/material/styles";

interface TextFieldFramedProps {
    value: string;
    disabled?: boolean;
}

/**
 *  In some widgets, the text field is with white background and a border around. This widget is used at least in
 *  new order and DataDownloadDialog.
 */

export const TextFieldFramed: React.FC<TextFieldFramedProps> = ({value, disabled = true, ...props}) => {
    return (
        <TextField
            hiddenLabel
            margin="none"
            size="small"
            fullWidth
            value={value}
            disabled={disabled}
            sx={{
                "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: (theme: Theme) => (theme.palette.dark as SimplePaletteColorOptions).main, //without this doesn't work In Chrome & Safari
                    color: (theme: Theme) => (theme.palette.dark as SimplePaletteColorOptions).main,
                },
            }}
            {...props}
        />
    );
};
